import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  insightsNavItems,
  InsightsNavItem,
  isInsightsNavItemActive,
} from '../insights-nav';

@Component({
  selector: 'app-insights-layout',
  imports: [RouterOutlet],
  templateUrl: './insights-layout.html',
  host: { class: 'block h-full w-full min-h-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsightsLayout {
  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects.split('?')[0] ?? ''),
      startWith(this.router.url.split('?')[0] ?? ''),
    ),
    { initialValue: this.router.url.split('?')[0] ?? '' },
  );

  readonly navItems = computed(() => insightsNavItems);

  readonly activeNavRoute = computed(() => {
    const url = this.currentUrl();
    const active = this.navItems().find((item) => isInsightsNavItemActive(item, url));
    return active?.route ?? this.navItems()[0]?.route ?? '/insights/brand';
  });

  goToNavItem(item: InsightsNavItem): void {
    void this.router.navigate([item.route]);
  }

  selectNavMobile(event: Event): void {
    const route = (event.target as HTMLSelectElement).value;
    void this.router.navigate([route]);
  }

  getNavButtonClass(item: InsightsNavItem): string {
    const active = isInsightsNavItemActive(item, this.currentUrl());

    if (active) {
      return 'bg-gray-200 text-gray-900 dark:bg-white/10 dark:text-gray-200';
    }

    return 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200';
  }
}
